import React, { useMemo } from 'react';

import classnames from 'classnames';

import Typography from 'components/uiLibrary/Typography';

import { TAG_TYPES } from 'constants/index';

import { getProductionTags } from 'utils/productions';

import { useTranslation } from 'src/i18n';

import classes from './GenreTags.module.scss';

const TagsList = ({ tagsList, styles }) => {
  const { t } = useTranslation('NS_DISPLAY_V4');
  return (
    <div className={classnames(classes.tagsList, { [styles?.tagsList]: !!styles?.tagsList })}>
      {tagsList?.map((tag, index) => (
        <Typography key={index} color="tertiary" size={12} className={classes.tag} textTransform="uppercase" truncate>
          {t(tag?.label)}
        </Typography>
      ))}
    </div>
  );
};

const GenreTags = ({
  production,
  isExpanded = false,
  truncateWorkType,
  showGenre = true,
  showStagingType = true,
  showTags = true,
  styles,
}) => {
  const genre = useMemo(() => {
    if (production?.genre) {
      return production.genre?.split('||').filter(gen => gen && gen.trim() !== '');
    }

    const { productionWorkToWorkTypes } = production?.productionWorks?.[0] || {};
    const workType = productionWorkToWorkTypes?.[0]?.workType?.name || '';
    const stagingType = (showStagingType && productionWorkToWorkTypes?.[0]?.stagingType?.name) || '';

    return [workType, stagingType].filter(Boolean);
  }, []);

  const tagsList = useMemo(() => {
    if (!showTags) {
      return [];
    }

    if (production?.tags) {
      return production.tags;
    }

    return getProductionTags(production, [TAG_TYPES.PRODUCTION, TAG_TYPES.DATE], true);
  }, []);

  return (
    <div
      className={classnames(classes.genreTags, {
        [classes.genreTagsExpanded]: !!isExpanded,
        [styles?.rootTags]: !!styles?.rootTags,
      })}
    >
      <span className={classes.genre}>
        {showGenre && (
          <Typography
            color="secondary"
            size={11}
            textTransform="uppercase"
            weight="medium"
            className={classes.workTypeOne}
            truncate={truncateWorkType}
          >
            {genre?.[0]}
          </Typography>
        )}
        {showStagingType && genre?.[1] && (
          <Typography color="tertiary" className={classes.workTypeOne} size={12}>
            {genre[1]}
          </Typography>
        )}
        <TagsList tagsList={tagsList} styles={styles} />
      </span>
    </div>
  );
};

export default GenreTags;
